import * as React from "react";
import styled from "styled-components";

import Button from "../Button";
import Modal from "../Modal";
import { useForm } from "react-typed-form";
import { Config, Domain } from "../../../constants";
import { FieldText, SubmitButton, FieldSelect } from "../../../form/legacy";
import { submitHubspotForm } from "../../../hubspot";

export default function SpecialSliceDownloadRdfTemplate() {
  const [modalVisible, setModalVisible] = React.useState<boolean>(false);
  const [success, setSuccess] = React.useState<boolean>(false);

  const { getField, handleSubmit, isLoading, reset, setLoading } = useForm<{
    firstname: string | null;
    lastname: string | null;
    email: string | null;
    company: string | null;
    company_type: string | null;
  }>({
    validate: (values) => {
      const errors: any = {};
      ["firstname", "email", "company"]
        .filter((k) => !(values as any)[k])
        .forEach((k) => {
          errors[k] = ["This field cannot be left blank"];
        });
      return errors;
    },
    onSubmit: async (values, { setLoading }) => {
      setLoading(true);
      const result = await submitHubspotForm(
        "c6979669-e41a-4329-8c46-f8ad48f8a9b8",
        values
      );
      setSuccess(result);
    },
  });

  return (
    <>
      <StyledSlice>
        <Button
          color="darkBlue"
          label="Download Template"
          onClick={() => setModalVisible(true)}
        />
      </StyledSlice>

      {modalVisible && (
        <Modal
          onDismiss={() => {
            setModalVisible(false);
            setLoading(false);
            reset();
          }}
        >
          {success ? (
            <>
              <h2>Document Automation RFP Template</h2>

              <p>
                Thank you for registering. We've sent a copy to the e-mail
                address you gave us. You can also download the RFP template
                through the link below
              </p>

              <Button
                color="darkBlue"
                label="Shipamax Document Automation RFP Template"
                href="https://docs.google.com/spreadsheets/d/18qXSDvC04bf8Y3MdopiW8JTDGbiIo1AXXaNFpCmTNi4/edit?usp=sharing"
              />
            </>
          ) : (
            <>
              <h2>Enter your details to access this content</h2>
              <StyledForm
                onSubmit={(ev) => {
                  ev.preventDefault();
                  handleSubmit();
                }}
              >
                <FieldText
                  field={getField("firstname")}
                  label="First Name"
                  required
                  bordered
                />
                <StyledFormSpacer />
                <FieldText
                  field={getField("lastname")}
                  label="Last Name"
                  bordered
                />
                <StyledFormSpacer />
                <FieldText
                  field={getField("email")}
                  label="Business Email"
                  required
                  bordered
                />
                <StyledFormSpacer />
                <FieldText field={getField("company")} required bordered />
                <StyledFormSpacer />
                <FieldSelect
                  field={getField("company_type")}
                  choices={Domain.contactCompanyTypes.map((x) => ({
                    label: x,
                    value: x,
                  }))}
                  label="Sector"
                  bordered
                />
                <StyledFormSpacer />
                <SubmitButton isLoading={isLoading} />
              </StyledForm>
            </>
          )}
        </Modal>
      )}
    </>
  );
}

const StyledSlice = styled.div`
  display: flex;
  justify-content: center;
  padding: 30px 0;
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin: 0;
  padding: 0;
`;

const StyledFormSpacer = styled.div`
  height: 20px;
`;
